// galaxyUtils.js
import axiosConn from '../axiosConn';

const idOf = (value) => String(value?._id || value || '');
export const isPlayerAuthorized = (galaxy, player) => {
  const actor = player?.data?.player;
  if (!galaxy || !actor || actor.active === false) return false;
  if (actor.role === 'admin') return true;
  return ['galaxyAdmin', 'moderator'].includes(actor.role) &&
    ['owners', 'administrators', 'moderators'].some((key) =>
      (galaxy[key] || []).some((value) => idOf(value) === idOf(actor)));
};

export const handleRemoveSubscriber = async (galaxy, player, subscriberId, setSubscribers, subscribers) => {
  if (!isPlayerAuthorized(galaxy, player)) throw new Error('Galaxy membership access denied');
  const response = await axiosConn.delete(`galaxies/${galaxy._id}/remove/${subscriberId}`, {
    headers: { Authorization: `Bearer ${player.token}` },
  });
  if (response.status !== 200) throw new Error('Removal was not confirmed');
  setSubscribers(subscribers.filter((subscriber) => subscriber._id !== subscriberId));
  return response;
};
